import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
  SheetTrigger,
} from '@/components/ui/sheet'
import { AddButton } from '@/components/common/AddButton'
import { usePermission } from '@/features/auth/store'
import { CustomerCreateForm } from './CustomerCreateForm'

interface CustomerCreateButtonProps {
  /** When set, navigate to the new customer's detail page on success. Default true. */
  navigateOnSuccess?: boolean
}

export function CustomerCreateButton({ navigateOnSuccess = true }: CustomerCreateButtonProps) {
  const canCreate = usePermission('partners.customer.create')
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  if (!canCreate) return null

  const handleSuccess = (id: number) => {
    setOpen(false)
    if (navigateOnSuccess) navigate(`/clients/${id}`)
  }

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <AddButton>Dodaj klienta</AddButton>
      </SheetTrigger>
      <SheetContent side="right" className="w-full sm:max-w-lg overflow-y-auto">
        <SheetHeader>
          <SheetTitle>Nowy klient</SheetTitle>
          <SheetDescription>
            Wypełnij dane podstawowe. Telefony, emaile i adresy dodasz po utworzeniu.
          </SheetDescription>
        </SheetHeader>
        <div className="px-4 pb-6">
          <CustomerCreateForm onSuccess={handleSuccess} onCancel={() => setOpen(false)} />
        </div>
      </SheetContent>
    </Sheet>
  )
}
